import classNames from 'classnames';
import FormattedCurrency from '../FormattedCurrency';
import './style.scss';

type PriceProps = {
  price: number;
  isDiscounted?: boolean;
  isInactive?: boolean;
  isLarge?: boolean;
};

const Price = (props: PriceProps) => {
  const { price, isDiscounted, isInactive, isLarge } = props;
  return (
    <div
      className={classNames('price', {
        'price--discounted': isDiscounted,
        'price--inactive': isInactive,
        'price--large': isLarge,
      })}
    >
      <FormattedCurrency value={price / 100} />
    </div>
  );
};

export default Price;
